import { Map as iMap } from 'immutable';

import * as constants from './helpwidget-constants';

const initialState = iMap({
  isKnowledgeBaseActive: true,
  isLiveChatActive: false,
  isSupportDeskActive: false,
  isNewFeaturesActive: false,
  newFeaturesCount: 0,
  isTourActive: false,
});

export function helpwidget(state = initialState, action) {
  switch (action.type) {
    case constants.LIVE_CHAT_ACTIVE:
      return state.set('isLiveChatActive', true);
    case constants.LIVE_CHAT_INACTIVE:
      return state.set('isLiveChatActive', false);
    case constants.SUPPORT_DESK_ACTIVE:
      return state.set('isSupportDeskActive', true);
    case constants.NEW_FEATURES_ACTIVE:
      return state.set('isNewFeaturesActive', true);
    case constants.RECEIVE_NEW_FEATURES:
      return state.set('newFeaturesCount', action.payload.count);
    default:
      return initialState.merge(state);
  }
}



// WEBPACK FOOTER //
// ./src/app/stores/ui/components/helpwidget/helpwidget-reducer.js